/* tslint:disable */

declare var Object: any;
export interface MeetingAttendeesInterface {
  "sfdcId"?: string;
  "CreatedById"?: string;
  "CreatedDate"?: Date;
  "CurrencyIsoCode"?: string;
  "LastModifiedById"?: string;
  "Name"?: string;
  "OwnerId"?: string;
  "Attendee__c"?: string;
  "Conducted_By__c"?: string;
  "IRON_ExtID__c"?: string;
  "Meeting__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class MeetingAttendees implements MeetingAttendeesInterface {
  "sfdcId": string;
  "CreatedById": string;
  "CreatedDate": Date;
  "CurrencyIsoCode": string;
  "LastModifiedById": string;
  "Name": string;
  "OwnerId": string;
  "Attendee__c": string;
  "Conducted_By__c": string;
  "IRON_ExtID__c": string;
  "Meeting__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: MeetingAttendeesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `MeetingAttendees`.
   */
  public static getModelName() {
    return "MeetingAttendees";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of MeetingAttendees for dynamic purposes.
  **/
  public static factory(data: MeetingAttendeesInterface): MeetingAttendees{
    return new MeetingAttendees(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'MeetingAttendees',
      plural: 'MeetingAttendees',
      path: 'MeetingAttendees',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "Attendee__c": {
          name: 'Attendee__c',
          type: 'string'
        },
        "Conducted_By__c": {
          name: 'Conducted_By__c',
          type: 'string'
        },
        "IRON_ExtID__c": {
          name: 'IRON_ExtID__c',
          type: 'string'
        },
        "Meeting__c": {
          name: 'Meeting__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
